module.exports = __webpack_public_path__ + "media/images/client-authority-brands-2-7943f941a9c53be1f097bf867a44a13c.png";